import React, { useEffect, useState } from 'react';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Table from 'react-bootstrap/Table';
import Button from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form';

export default function Settings() {
    const [modems, setModems] = useState([]);

    const defaultThresholds = {
        "Converted Float Cannon": 15000,
        "Converted Land Cannon": 15000,
        "Margo Float Cannon": 15000,
        "Margo Float SquawkBox": 15000,
        "Margo Land Cannon": 15000
    };

    const [tankThresholds, setTankThresholds] = useState(() => {
        const saved = localStorage.getItem("tankThresholds");
        return saved ? JSON.parse(saved) : defaultThresholds;
    });

    useEffect(() => {
        fetchModemSettings();
    }, []);

    const fetchModemSettings = async () => {
        try {
            const res = await fetch("/api/v1/modems/", {
                headers: { "X-API-KEY": "7EAFDEADBEEF" }
            });
            const data = await res.json();
            setModems(data);
        } catch (err) {
            toast.error("Failed to fetch modem settings");
            console.error(err);
        }
    };

    const handleInputChange = (index, field, value) => {
        setModems(prev => {
            const updated = [...prev];
            updated[index] = {
                ...updated[index],
                [field]: field === 'latitude' || field === 'longitude' ? parseFloat(value) : value
            };
            return updated;
        });
    };

    const handleSave = async (modem) => {
        if (isNaN(modem.latitude) || isNaN(modem.longitude)) {
            toast.error("Latitude and Longitude must be valid numbers");
            return;
        }

        try {
            const res = await fetch("/api/v1/modems/update/", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    "X-API-KEY": "7EAFDEADBEEF"
                },
                body: JSON.stringify({
                    id: modem.id,
                    name: modem.name,
                    latitude: modem.latitude,
                    longitude: modem.longitude
                })
            });

            if (res.ok) {
                toast.success("Modem settings saved");
            } else {
                toast.error("Failed to save modem settings");
            }
        } catch (err) {
            console.error(err);
            toast.error("Network error");
        }
    };

    return (
        <div className="container mt-4">
            <h2>Settings</h2>
            <h4 className="mt-4">Modem Locations</h4>
            <Table striped bordered hover>
                <thead>
                    <tr>
                        <th>ID</th>
                        <th>IP</th>
                        <th>Name</th>
                        <th>Latitude</th>
                        <th>Longitude</th>
                        <th>Save</th>
                    </tr>
                </thead>
                <tbody>
                    {modems.map((modem, index) => (
                        <tr key={modem.id}>
                            <td>{modem.id}</td>
                            <td>{modem.ip}</td>
                            <td>
                                <Form.Control
                                    type="text"
                                    value={modem.name || ''}
                                    onChange={(e) => handleInputChange(index, 'name', e.target.value)}
                                />
                            </td>
                            <td>
                                <Form.Control
                                    type="number"
                                    step="any"
                                    value={modem.latitude}
                                    onChange={(e) => handleInputChange(index, 'latitude', e.target.value)}
                                />
                            </td>
                            <td>
                                <Form.Control
                                    type="number"
                                    step="any"
                                    value={modem.longitude}
                                    onChange={(e) => handleInputChange(index, 'longitude', e.target.value)}
                                />
                            </td>
                            <td>
                                <Button variant="success" onClick={() => handleSave(modem)}>Save</Button>
                            </td>
                        </tr>
                    ))}
                </tbody>
            </Table>
            <h4 className="mt-5">Tank Counter Thresholds</h4>
            <Table striped bordered hover>
                <thead>
                    <tr>
                        <th>Device Type</th>
                        <th>Tank Threshold</th>
                    </tr>
                </thead>
                <tbody>
                    {Object.keys(tankThresholds).map((type) => (
                        <tr key={type}>
                            <td>{type}</td>
                            <td>
                                <Form.Control
                                    type="number"
                                    value={tankThresholds[type]}
                                    onChange={(e) => {
                                        const updated = {
                                            ...tankThresholds,
                                            [type]: parseInt(e.target.value || "0")
                                        };
                                        setTankThresholds(updated);
                                        localStorage.setItem("tankThresholds", JSON.stringify(updated));
                                    }}
                                />
                            </td>
                        </tr>
                    ))}
                </tbody>
            </Table>

        </div>
    );
}
